import React from "react";

const PestAndDiseaseRoot = () => {
  return (
			<div></div>
	)
}

export default PestAndDiseaseRoot;